import * as FavoritesUpdatedEvent from '@ori-events/favorites-updated';
import type { Dispatch, SetStateAction } from 'react';
import { useCallback } from 'react';

import { useEventListener } from './useEventListener';

export interface UseUpdateProductsOnFavoritesUpdatedEventParams {
  areFavoriteProductCodesLoaded: boolean;
  setAllFavoriteProductCodes: Dispatch<SetStateAction<string[]>>;
  setAreFavoriteProductCodesLoaded?: Dispatch<SetStateAction<boolean>>;
  setAreFavoritesLoaded: Dispatch<SetStateAction<boolean>>;
}

export const useUpdateProductsOnFavoritesUpdatedEvent = ({
  areFavoriteProductCodesLoaded,
  setAllFavoriteProductCodes,
  setAreFavoriteProductCodesLoaded,
  setAreFavoritesLoaded,
}: UseUpdateProductsOnFavoritesUpdatedEventParams) => {
  const updateAllFavoriteProductCodes = useCallback(
    ({ detail: { favorites } }: FavoritesUpdatedEvent.Event) => {
      if (!areFavoriteProductCodesLoaded) {
        setAllFavoriteProductCodes(favorites);

        if (favorites.length === 0) {
          setAreFavoriteProductCodesLoaded?.(true);
          setAreFavoritesLoaded(true);
        }
      }
    },
    [
      areFavoriteProductCodesLoaded,
      setAllFavoriteProductCodes,
      setAreFavoriteProductCodesLoaded,
      setAreFavoritesLoaded,
    ],
  ) as EventListener;
  useEventListener(FavoritesUpdatedEvent.Name, updateAllFavoriteProductCodes);
};
